import truncateText from '@/utils/truncate-text'

const getDefaultState = () => {
  return {
    // Place any new state properties here
    loadingCount: 0,
    crudLoadingCount: 0,
    notificationPermission: Notification.permission,
  }
}

const state = getDefaultState()

export default {
  namespaced: true,
  state,
  getters: {
    hasGrantedNotificationPermission: (state) =>
      state.notificationPermission === 'granted',

    // Function to check whether browser supports the promise version of requestPermission()
    // Safari only supports the old callback-based version
    doesBrowserSupportNotificationPromise: () => {
      try {
        Notification.requestPermission().then()
      } catch (e) {
        return false
      }

      return true
    },

    doesBrowserSupportNotifications: () => {
      return 'Notification' in window
    },

    isLoading: (state) => state.loadingCount > 0,
    isLoadingCRUD: (state) => state.crudLoadingCount > 0,
  },
  mutations: {
    START_LOADING(state) {
      state.loadingCount++
    },
    FINISH_LOADING(state) {
      state.loadingCount--
    },
    START_LOADING_CRUD(state) {
      state.crudLoadingCount++
    },
    FINISH_LOADING_CRUD(state) {
      state.crudLoadingCount--
    },
    SET_NOTIFICATION_PERMISSION(state, permission) {
      state.notificationPermission = permission
    },
    CLEAR_STORE(state) {
      // Resets store to default state
      Object.assign(state, getDefaultState())
    },
  },
  actions: {
    handlePermission({ commit }, permission) {
      // Older versions of Chrome didn't store the answer of notification permissions
      // so let's ensure it's stored
      if (!('permission' in Notification)) {
        Notification.permission = permission
      }

      commit('SET_NOTIFICATION_PERMISSION', permission)
    },
    async askNotificationPermission({ getters, dispatch }) {
      if (!getters.doesBrowserSupportNotifications) {
        throw new Error('This browser does not support the Notifications API')
      }

      if (getters.doesBrowserSupportNotificationPromise) {
        return await Notification.requestPermission().then(
          async (permission) => {
            return await dispatch('handlePermission', permission)
          }
        )
      } else {
        return Notification.requestPermission(async function(permission) {
          return await dispatch('handlePermission', permission)
        })
      }
    },

    createNotification(context, { firstName, lastName, message }) {
      // Create and show the notification
      const icon =
        'https://anzukmedia.blob.core.windows.net/logos/PNG/logo_anzuk_dark_icon%400.75x.png'
      const title = `SMS From ${firstName} ${lastName} (Candidate)`
      const body = truncateText(message.content, 80)

      // eslint-disable-next-line no-unused-vars
      const notification = new Notification(title, {
        body,
        icon,
      })
    },

    /**
     * Resets store to default state.
     */
    clear({ commit }) {
      commit('CLEAR_STORE')
    },
  },
}
